var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.269,
    height: 15.251,
    viewBox: "0 0 16.269 15.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00959c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.452)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.452)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.967,16.126a.512.512,0,0,0-.418-.108L.415,17.544a.507.507,0,0,0-.415.5V29.228a.508.508,0,0,0,.415.5l8.134,1.525a.486.486,0,0,0,.094.009.508.508,0,0,0,.508-.508V16.518A.507.507,0,0,0,8.967,16.126ZM8.134,30.14,1.017,28.806V18.465l7.118-1.334Z",
    transform: "translate(0 -16.01)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.134 2.033)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M263.626,79.99h-7.118a.508.508,0,1,0,0,1.017h6.609v9.151h-6.609a.508.508,0,1,0,0,1.017h7.118a.509.509,0,0,0,.508-.508V80.5A.509.509,0,0,0,263.626,79.99Z",
    transform: "translate(-256 -79.99)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.134 4.067)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M258.542,143.99h-2.034a.508.508,0,1,0,0,1.017h2.034a.508.508,0,0,0,0-1.017Z",
    transform: "translate(-256 -143.99)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.134 6.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M258.542,207.99h-2.034a.508.508,0,1,0,0,1.017h2.034a.508.508,0,0,0,0-1.017Z",
    transform: "translate(-256 -207.99)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.134 8.134)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M258.542,271.99h-2.034a.508.508,0,1,0,0,1.017h2.034a.508.508,0,0,0,0-1.017Z",
    transform: "translate(-256 -271.99)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.134 10.167)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M258.542,335.99h-2.034a.508.508,0,1,0,0,1.017h2.034a.508.508,0,0,0,0-1.017Z",
    transform: "translate(-256 -335.99)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.202 4.067)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M385.525,143.99h-1.017a.508.508,0,1,0,0,1.017h1.017a.508.508,0,0,0,0-1.017Z",
    transform: "translate(-384 -143.99)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.202 6.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M385.525,207.99h-1.017a.508.508,0,1,0,0,1.017h1.017a.508.508,0,0,0,0-1.017Z",
    transform: "translate(-384 -207.99)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.202 8.134)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M385.525,271.99h-1.017a.508.508,0,1,0,0,1.017h1.017a.508.508,0,0,0,0-1.017Z",
    transform: "translate(-384 -271.99)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.202 10.167)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M385.525,335.99h-1.017a.508.508,0,1,0,0,1.017h1.017a.508.508,0,0,0,0-1.017Z",
    transform: "translate(-384 -335.99)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.542 5.083)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M84.455,180.225,80.9,176.158a.508.508,0,0,0-.766.669l3.559,4.067a.508.508,0,0,0,.766-.669Z",
    transform: "translate(-80.004 -175.984)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.542 4.575)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M84.379,160.1a.508.508,0,0,0-.714.088l-3.559,4.576a.509.509,0,0,0,.8.625l3.559-4.576A.508.508,0,0,0,84.379,160.1Z",
    transform: "translate(-79.999 -159.992)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.8545e30e7764be94a4e9522370bb5d6f.svg";
export { ForwardRef as ReactComponent };